import { useContext, useEffect } from "react";
import { NavigationContext } from "../../Context/NavigationContext";

const mainIFrameID = "lddIFrame"
const iframeContentID = 'iframe-content'
export const MainIFrame = (props) => {
    const nav = useContext(NavigationContext);
    useEffect(() => {
        nav({ ...props.page, init: true });
    }, [])
    return (
        <div id={mainIFrameID} className="justify-content-center text-center iframeBox">
            <iframe title="IFrame" id={iframeContentID} src={`${process.env.REACT_APP_DR_ENDPOINT}/LawyerAccounting.asp?SessionID=${props.sid}&NoHeader=1`} />
        </div>
    );
}